var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon_giftcard flex"},[_c('figure',{style:('background-image: url(' + _vm.logoLight + ')')}),_c('hgroup',[_c('h4',[_vm._v("\n      Giftcard\n    ")]),_c('cite',[_vm._v(_vm._s(_vm.name))]),_c('cite',[_vm._v(_vm._s(_vm.email))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }